import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { getPackages } from '../../../features/packageSlice'
import { openModal, setModalData } from '../../../features/commonSlice'
import { formatCommonAmount } from '../../../util/formatAmount'
import styles from './index.module.scss'

const PackagesCard = ({ cardStyle, setSelectedPackage }) => {
    const dispatch = useDispatch()
    const reduxPackages = useSelector((state) => state.packages.packages)
    const { userId } = useParams()
    const accountType = useSelector((state) => state.auth.accountType)
    useEffect(() => {
		if (userId) {
			dispatch(getPackages({ vendorId: userId }))
		}
	}, [dispatch, userId])

    const packages = useMemo(() => {
        return reduxPackages || []
    }, [reduxPackages])

    return (
        <div sx={cardStyle} className={`${styles.cardWrp} ${styles.packagesCard}`}>
            <div className={styles.infoHeader}>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: 'bold' }}
                >
                    Packages ({packages.length})
                </Typography>
            </div>
            <div className={styles.packagesWrp}>
                {packages.map((pkg) => (
                    <div key={pkg?._id} className={styles.packageItem}>
                        <div className={styles.packageImageWrp}>
                            <img src={pkg.image || '/images/placeholder.png'} alt={pkg.name} className={styles.packageImage} loading="lazy"/>
                            <p className={styles.packageImageOverlay}>
                                Add-ons ({pkg?.addOnsIds?.length || 0})
                            </p>
                        </div>
                        <div className={styles.packageContent}>
                            <h6 className={styles.packageTitle}>{pkg?.name || '--'}</h6>
                            <p className={styles.packageDescription}>{pkg?.description || '--'}</p>
                            <div className={styles.packageFooter}>
                                <div className={styles.packagePrice}>
                                    <span className={styles.priceValue}>{formatCommonAmount(pkg?.price)}</span>
                                </div>
                                {accountType === 'user' && <ButtonCustom
                                    variant="outlined"
                                    size="sm"
                                    className={styles.viewDetailsBtn}
                                    onClick={() => {
                                        dispatch(openModal('requestProposal'));
                                        const selectedAddOns = pkg?.addOnsIds?.flatMap(addon =>
                                            addon?.isThisAddOnIsRequired ? [addon._id] : []
                                        ) ?? [];
                                        setSelectedPackage({
                                            ...pkg,
                                            selectedAddOns
                                        })
                                    }}
                                >
                                    Select Package
                                </ButtonCustom>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PackagesCard